
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 40 40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"20","cy":"20","r":"20","fill":"#fff"}}),_c('path',{attrs:{"d":"M20 0C8.941 0 0 8.941 0 20s8.941 20 20 20 20-8.941 20-20S31.059 0 20 0zm9.02 19.804c0 2.784-.824 5.45-2.392 7.725a13.7 13.7 0 01-6.118 4.942c-.157.078-.314.078-.47.078-.158 0-.314-.04-.471-.078-2.471-1.02-4.628-2.706-6.118-4.942a13.529 13.529 0 01-2.392-7.725v-6c0-.55.392-1.059.902-1.216l7.255-2.117a3.22 3.22 0 011.725 0l7.255 2.117c.55.157.902.667.902 1.216v6h-.078z"}})])
          )
        }
      }
    